import * as React from 'react'
import { connect } from 'react-redux'
import { ContactCreateComponent } from './ContactCreate'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'
import { push } from 'react-router-redux'
import { createContact } from '../Contacts.actions'

const formName = 'contactCreate'

export interface IContactCreateContainerProps {
  onAfterSubmit: () => undefined
  initialValues?: object
}

const stateToProps = () => ({})

export const dispatchToProps = {
  push,
  createContact,
}

export const ContactCreate = flow<any, any, React.SFC<IContactCreateContainerProps>>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(ContactCreateComponent)



// WEBPACK FOOTER //
// src/features/Contacts/ContactCreate/ContactCreate.container.ts